import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import WordLists from "./pages/WordLists";
import MyWordsEdit from "./pages/MyWordsEdit";
import WordListDetail from "./pages/WordListDetail";
import Practice from "./pages/Practice";
import TestMode from "./pages/TestMode";
import Listen from "./pages/Listen";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import RequireAdmin from "./components/RequireAdmin";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/wordlists" element={<WordLists />} />
            <Route path="/my-words" element={<MyWordsEdit />} />
            <Route path="/wordlists/:id" element={<WordListDetail />} />
            <Route path="/practice/:id" element={<Practice />} />
            <Route path="/listen/:id" element={<Listen />} />
            <Route path="/test/:id" element={<TestMode />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
